module.exports = __webpack_public_path__ + "static/media/meteor.4e8d3a67.svg";